module.exports = __webpack_public_path__ + "img/亚马逊.2c53dcfe.png";